import { bootstrapStaff } from "./bootstrapStaff";

bootstrapStaff();
